import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { SlideLayout, itemVariants } from '../ui/SlideLayout';
const rows = [{
  label: 'Reprogrammability',
  asic: 'None — frozen at fab',
  fpga: 'Full — gates reconfigure',
  gpu: 'Software only'
}, {
  label: 'Power Efficiency',
  asic: 'Best',
  fpga: 'Very high',
  gpu: 'Moderate–High'
}, {
  label: 'Memory Architecture',
  asic: 'Fixed, custom',
  fpga: 'Custom hierarchies (BRAM/URAM)',
  gpu: 'Shared HBM, virtual memory'
}, {
  label: 'Latency Determinism',
  asic: 'Cycle-level',
  fpga: 'Cycle-level',
  gpu: 'Non-deterministic (driver scheduling)'
}, {
  label: 'NRE Cost',
  asic: '$5M–$100M+',
  fpga: 'Near zero',
  gpu: 'Near zero'
}, {
  label: 'Time to New Model',
  asic: 'Months–years (new chip)',
  fpga: 'Days–weeks (recompile)',
  gpu: 'Hours–days (software)'
}, {
  label: 'Peak Performance',
  asic: 'Highest',
  fpga: '~90% of ASIC',
  gpu: 'High (batch-dependent)'
}, {
  label: 'Low-Batch Efficiency',
  asic: 'Excellent',
  fpga: 'Excellent',
  gpu: 'Poor (70–80% idle)'
}];
export function AppendixA1Slide() {
  return <SlideLayout data-id="element-13" data-mp="2pmmsjpgqo29b">
      <motion.div variants={itemVariants} className="mb-10" data-id="element-14" data-mp="2pm4tkl2oz9xp">
        <p className="text-brand-teal font-mono text-xs tracking-widest uppercase mb-3" data-id="element-15" data-mp="2koura4u7f3sg">
          Appendix A1
        </p>
        <h2 className="text-3xl md:text-4xl font-bold text-brand-text" data-id="element-16" data-mp="2fqa0sx4r7yh7">
          FPGA vs GPU vs ASIC — Technical Deep Dive
        </h2>
      </motion.div>

      <motion.div variants={itemVariants} className="overflow-x-auto" data-id="element-17" data-mp="26wy3ue3hdi2e">
        <table className="w-full text-sm" data-id="element-18" data-mp="26x6gc4voyld2">
          <thead data-id="element-19" data-mp="21ydexatoikt9">
            <tr className="border-b border-brand-border" data-id="element-20" data-mp="21ywljvdvpmrz">
              <th className="text-left py-3 pr-4 text-brand-text-muted font-medium w-1/4" data-id="element-21" data-mp="1wyr0wz6110je"></th>
              <th className="text-left py-3 px-4 text-brand-text-dim font-semibold" data-id="element-22" data-mp="1x0laxifrf88p">
                ASIC
              </th>
              <th className="text-left py-3 px-4 text-brand-teal font-semibold" data-id="element-23" data-mp="1ibiltn9lkb25">
                FPGA
              </th>
              <th className="text-left py-3 px-4 text-brand-text-dim font-semibold" data-id="element-24" data-mp="1nc67ruiyy1pi">
                GPU
              </th>
            </tr>
          </thead>
          <tbody data-id="element-25" data-mp="1dcyxjg7j6n6m">
            {rows.map((row, i) => <tr key={row.label} className="border-b border-brand-border/50" data-id="element-26" data-mp="1ddh1z04ck7pm" data-mpi={i}>
                <td className="py-3 pr-4 text-brand-text font-medium" data-id="element-27" data-mp="213ksc5siyayo">
                  {row.label}
                </td>
                <td className="py-3 px-4 text-brand-text-dim" data-id="element-28" data-mp="2614ju7e8gk8k">{row.asic}</td>
                <td className="py-3 px-4 text-brand-text bg-brand-teal/5" data-id="element-29" data-mp="1s96hcff11mld">
                  {row.fpga}
                </td>
                <td className="py-3 px-4 text-brand-text-dim" data-id="element-30" data-mp="1wa9s4ni7wsfq">{row.gpu}</td>
              </tr>)}
          </tbody>
        </table>
      </motion.div>

      <motion.div variants={itemVariants} className="mt-8 flex gap-4 text-xs text-brand-text-muted" data-id="element-31" data-mp="2osngzxlkt42o">
        <span data-id="element-32" data-mp="dbu2jtgqxrc1">
          References: FlightLLM benchmarks, Goldman Sachs AI Infrastructure
          Report
        </span>
      </motion.div>
    </SlideLayout>;
}